import { StateService } from '@uirouter/angular';
import { Injectable } from '@angular/core';
import { GfTranslateService } from '../../../services/core.translate.service';
import { ProjectService } from '../../../services/project.service';
import { UiService } from '../../../services/core.ui.service';
import { buildQueryString } from '../../../config/core.httpclient-utils';

import * as _ from 'lodash';

@Injectable()
export class ProjectReportsData {

    constructor(
        private $window: Window,
        private gfTranslateService: GfTranslateService,
        private projectService: ProjectService,
        private uiService: UiService,
        private stateService: StateService,
    ) { }

    getProjectMembers() {
        const stateParams = this.stateService.params;
        const params = {
            group: true,
            page_size: 0
        };

        return new Promise(
            (resolve) => {
                this.projectService.members(stateParams.unixName, params)
                .then(
                    (response) => {
                        resolve(_.get(response, 'items', []));
                    },
                    (response) => {
                        var msg = this.gfTranslateService.translate(
                            'There was a problem loading project members for {{unixName}}',
                            stateParams.unixName
                        );
                        this.uiService.message.showWarning(msg, 'Data Error');
                        resolve([]);
                    }
                );    
            }
        );
    }

    /**
        * This function is used to check filters selected for the search and build the
        * search filters object
    */
    applyFilters(filters) {
        var _params = {};

        _.each(filters.main_fields, function (filter) {
            if (_.isObject(filter.value)) {
                if (_.has(filter.value, 'id') && filter.value.id != '') {
                    _params[filter.alias] = filter.value.id;
                }
            } else {
                if (filter.value != "") {
                    _params[filter.alias] = filter.value;
                }
            }
        });

        return _params;
    }

    runReport = (params, format) => {
        var defaults = {
            download: true,
            report: true,
            format: format
        };

        const queryString = buildQueryString(
            Object.assign(defaults, params)
        );

        this.$window.open('/api/report?' + queryString, '_self');
    }

    setPieChartData(items) {
        var chartItems = [];
        _.each(items, function (item) {
            const y = parseInt(_.values(item)[1]);
            chartItems.push({
                key: _.values(item)[0],
                y: isNaN(y) ? 0 : y
            });
        });
        return chartItems;
    }    
}